import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface DriversIconProps {
  isSelected?: boolean;
  isHover?: boolean;
  style?: React.CSSProperties;
}

export default function DriversIcon({ isSelected = false, isHover = false, style = {}, ...props }: DriversIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 18" style={{ width: `20px`, height: `20px`, ...style }}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0002 8.10632C10.1096 8.10632 10.2186 8.10804 10.3272 8.11145C10.2168 8.11949 10.1052 8.12359 9.99241 8.12359C9.88127 8.12359 9.77121 8.11961 9.66239 8.11179C9.77452 8.10816 9.88712 8.10632 10.0002 8.10632ZM9.99241 9.12814C10.9521 9.12814 11.8564 8.88151 12.6353 8.44925C16.5986 9.50515 19.5567 12.8842 19.7303 16.9712L19.7308 16.9818V16.9925C19.7308 17.4667 19.3325 17.8429 18.8691 17.8429H15.6033C15.6034 17.8331 15.6034 17.8233 15.6034 17.8134C15.6034 14.7146 13.0913 12.2025 9.99242 12.2025C6.89357 12.2025 4.38145 14.7146 4.38145 17.8134C4.38145 17.8233 4.38148 17.8331 4.38153 17.8429H1.13118C0.690074 17.8429 0.247114 17.4824 0.270017 16.9705L0.270063 16.9695L0.769536 16.9925L0.269987 16.9712L0.270017 16.9705C0.443805 12.8874 3.3967 9.51103 7.35459 8.45204C8.13235 8.88257 9.03483 9.12814 9.99241 9.12814ZM14.6033 17.8429C14.6033 17.8331 14.6034 17.8233 14.6034 17.8134C14.6034 15.2669 12.539 13.2025 9.99242 13.2025C7.44585 13.2025 5.38145 15.2669 5.38145 17.8134C5.38145 17.8233 5.38149 17.8331 5.38155 17.8429H7.93645C7.93646 16.7033 8.86032 15.7794 9.99997 15.7794C11.1396 15.7794 12.0635 16.7033 12.0635 17.8429H14.6033Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.76517 4.13128C5.76517 1.96193 7.6315 0.157043 9.99241 0.157043C12.3533 0.157043 14.2197 1.96193 14.2197 4.13128C14.2197 6.30064 12.3533 8.10552 9.99241 8.10552C7.6315 8.10552 5.76517 6.30064 5.76517 4.13128Z"
          fill={isHover ? RoutalPalette.primary20 : isSelected ? RoutalPalette.primary40 : RoutalPalette.secondary40}
        />
      </g>
    </SvgIcon>
  );
}
